export default "__VITE_PUBLIC_ASSET__4c082fbb__"